/**
 *  OptimizationChart script file
**/
import * as d3 from 'd3'

export default {
  name: 'OptimizationChart',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {}
  },
  mounted () {
    this.drawChart()
  },
  computed: {
  },
  methods: {
    drawChart () {
      const wrapper = document.querySelector('.optimization-chart-container').getBoundingClientRect()
      const svg = d3.select(this.$refs.svg).attr('viewBox', [0, 0, wrapper.width, wrapper.height])
      const g = svg.append('g')

      g.append('path')
        .attr('class', 'base-line')
        .attr('d', this.drawBase(d3.path()))
        .attr('stroke', '#9397a2')
        .attr('stroke-width', 1)
        .attr('fill', 'none')

      g.append('path')
        .attr('class', 'base-line')
        .attr('d', this.drawLine(d3.path()))
        .attr('stroke', '#16969d')
        .attr('stroke-width', 3)
        .attr('fill', 'none')

      this.drawDot(g, [54, 65])
      this.drawDot(g, [101, 12])
    },
    drawBase (context) {
      context.moveTo(0, 70)
      context.bezierCurveTo(0, 73, 37, 70, 54, 65)
      context.bezierCurveTo(76, 58, 76, 48, 79, 37)
      context.bezierCurveTo(81, 30, 86, 18, 101, 12)
      context.bezierCurveTo(115, 6, 334, 0, 319, 0)
      return context
    },
    drawLine (context) {
      context.moveTo(54, 65)
      context.bezierCurveTo(76, 58, 76, 48, 79, 37)
      context.bezierCurveTo(81, 30, 86, 18, 101, 12)
      return context
    },
    drawDot (g, position) {
      g.append('circle')
        .attr('class', 'dot')
        .attr('cx', position[0])
        .attr('cy', position[1])
        .attr('r', 2)
        .attr('fill', '#ffffff')
        .attr('stroke', '#16969d')
        .attr('stroke-width', 1)
    }
  }
}
